<div *ngIf="landingPage.baseContentError$ | ngrxPush as baseContentError">
  <div
    (action)="redirect($event)"
    [error]="baseContentError.error"
    auraSkeletonLoader
  >
    <ng-container
      *ngIf="!baseContentError.error && landingPage.loaded$ | ngrxPush"
    >
      <idp-landing-page-ui
        *ngIf="{
          medallionBanner:
            (landingPage.medallionBanner$ | ngrxPush) || emptyMedallionBanner,
          menu: (landingPage.menu$ | ngrxPush) || emptyMenu
        } as content"
        [content]="content"
        [notification]="(landingPage.notification$ | async) || null"
      >
        <ng-content></ng-content>
      </idp-landing-page-ui>
    </ng-container>
  </div>
</div>
